import { ReactElement } from 'react';
import styles from './ShapeEditorOverlay.module.scss';
import { useTranslation } from 'react-i18next';
import { LatLngLiteral } from 'leaflet';

export interface ShapeEditorOverlayProps {
  position?: LatLngLiteral;
  circleRadius?: number;
}

export const ShapeEditorOverlay = ({
  position,
  circleRadius,
}: ShapeEditorOverlayProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {typeof circleRadius !== 'undefined' && (
        <div className={styles.section}>
          <div className={styles.section__label}>{t('Radius')}</div>
          <div className={styles.section__value}>{`${circleRadius} ${t('metres')}`}</div>
        </div>
      )}

      <div className={styles.section}>
        <div className={styles.section__label}>{t('CursorLocation')}</div>
        <div className={styles.section__value}>
          {typeof position !== 'undefined' ? `${position.lat}, ${position.lng}` : '-'}
        </div>
      </div>
    </div>
  );
};

export default ShapeEditorOverlay;
